var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { Button } from '~atoms';
import { useStyles } from './SelectionButton.styles';
var SelectionButton = React.forwardRef(function SelectionButton(_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.bordered, bordered = _b === void 0 ? false : _b, _c = _a.palette, palette = _c === void 0 ? 'dark' : _c, props = __rest(_a, ["className", "children", "bordered", "palette"]);
    var classes = useStyles();
    return (React.createElement(Button, __assign({}, props, { className: cn(className, classes.button, palette === 'light' && classes.light, bordered && classes.bordered), ref: ref }), children));
});
export { SelectionButton };
